/**
 * Utility functions for checking application status values.
 * These functions handle both deprecated statuses (SYSTEM_ACCEPTED, SYSTEM_REJECTED) 
 * and their newer replacements, making it easier to migrate away from deprecated values.
 */

/**
 * Check if the application status indicates system acceptance.
 * Includes both deprecated SYSTEM_ACCEPTED and newer status variants.
 * 
 * @param status - The application status string
 * @returns true if status is system accepted (deprecated or new variants)
 */
export function isSystemAccepted(status: string): boolean {
    return status === "SYSTEM_ACCEPTED" || // TODO: deprecated, can be removed after migration
           status === "STAFF_APPROVED_SYSTEM_ACCEPTED" ||
           status === "STUDENT_ACCEPTED_SYSTEM_ACCEPTED" ||
           status === "STUDENT_DECLINED_SYSTEM_ACCEPTED";
}

/**
 * Check if the application status indicates system rejection.
 * Includes both deprecated SYSTEM_REJECTED and newer status variants.
 * 
 * @param status - The application status string
 * @returns true if status is system rejected (deprecated or new variants)
 */
export function isSystemRejected(status: string): boolean {
    return status === "SYSTEM_REJECTED" || // TODO: deprecated, can be removed after migration
           status === "STAFF_APPROVED_SYSTEM_REJECTED" ||
           status === "STUDENT_ACCEPTED_SYSTEM_REJECTED" ||
           status === "STUDENT_DECLINED_SYSTEM_REJECTED";
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/ApplicationStatusUtil.ts